module.exports = __webpack_public_path__ + "resources/img/img_datatransporter_m.062b711b1d60ae0dc53b17bf26d87752.png";